import { render, staticRenderFns } from "./approveForm.vue?vue&type=template&id=3c54e2de&scoped=true&"
import script from "./approveForm.vue?vue&type=script&lang=js&"
export * from "./approveForm.vue?vue&type=script&lang=js&"
import style0 from "./approveForm.vue?vue&type=style&index=0&id=3c54e2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c54e2de",
  null
  
)

export default component.exports